import { render, staticRenderFns } from "./pbblist.vue?vue&type=template&id=2c05d8c4&scoped=true"
import script from "./pbblist.vue?vue&type=script&lang=js"
export * from "./pbblist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c05d8c4",
  null
  
)

export default component.exports